import React from "react";

const CheckboxFilledIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6667 1.33325H3.33337C2.2288 1.33325 1.33337 2.22868 1.33337 3.33325V12.6666C1.33337 13.7712 2.2288 14.6666 3.33337 14.6666H12.6667C13.7713 14.6666 14.6667 13.7712 14.6667 12.6666V3.33325C14.6667 2.22868 13.7713 1.33325 12.6667 1.33325ZM2.66671 3.33325C2.66671 2.96506 2.96518 2.66659 3.33337 2.66659H12.6667C13.0349 2.66659 13.3334 2.96506 13.3334 3.33325V12.6666C13.3334 13.0348 13.0349 13.3333 12.6667 13.3333H3.33337C2.96518 13.3333 2.66671 13.0348 2.66671 12.6666V3.33325ZM4.66671 3.99992C4.29852 3.99992 4.00004 4.2984 4.00004 4.66658V11.3333C4.00004 11.7014 4.29852 11.9999 4.66671 11.9999H11.3334C11.7016 11.9999 12 11.7014 12 11.3333V4.66659C12 4.2984 11.7016 3.99992 11.3334 3.99992H4.66671Z"
        fill="#537BFF"
      />
    </svg>
  );
};

export default CheckboxFilledIcon;
